import { useEffect, useState } from "react";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../../theme/Component/PrintJson";


interface Props {
    props: any;
    exportMap: Function;
    procedure: any;
    pushProps?: Function;
    pushInfo?: Function;
}

interface Resp {
    Obs: string;
    TipoSolicitud: number;
    Solicitud: string;
}

export const SP002 = ({ props, exportMap, pushInfo, pushProps }: Props) => {

    const [response, setResponse] = useState<Resp>({
        Obs: "",
        TipoSolicitud: 1,
        Solicitud: ''
    })
    const Tipos = [
        { id: 1, name: 'Adición Presupuestal' },
        { id: 2, name: 'Reducción Presupuestal' },
        { id: 3, name: 'Credito Contracredito' },
        { id: 4, name: 'Solicitud Registro presupuestal' },
    ]

    const onExportMap = () => {
        if (pushProps) {
            pushProps(response)
        }
        if (pushInfo) {
            let ms = "<p>";
            ms += response.Solicitud + " : <br>"
            ms += response.Obs
            ms += "</p>"
            pushInfo(ms)
        }
        exportMap(response)
    }

    useEffect(() => {
        let fil = Tipos.filter(item => item.id === response.TipoSolicitud);
        if (fil.length > 0) {
            setResponse({ ...response, "Solicitud": fil[0].name });
        }
    }, [response.TipoSolicitud])



    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <PrintJson json={props} />
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-checkbox-circle-line" eventClick={onExportMap} >Solicitar</BasicButton>
                </div>

            </div>

        </>
    );
};